<template>
  <div class="layout-default">
    <RysHeader class="header" />
    <div class="main">
      <slot />
    </div>
    <RysFooter class="footer" />
  </div>
</template>

<script setup lang="ts">
const menuStore = useMenuStore();
const optionsStore = useOptionsStore();

await Promise.all([
  callOnce(menuStore.fetchAll),
  callOnce(optionsStore.fetchAll)
]);
</script>

<style lang="scss" scoped>
.layout-default {
  position: relative;

  > * {
    position: relative;
  }

  > .header {
    z-index: 30;
  }

  > .main {
    z-index: 10;
  }

  > .footer {
    z-index: 9;
  }

  > .footer.faq {
    margin-top: 48px;
  }
}
</style>
